module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    //
                }
            },

            animation: {
                camelWiggle: 'camelWiggle 1s ease-in infinite',
                waveY3: 'waveY 2s ease-in-out infinite',
                waveY5: 'waveY 3s ease-in-out infinite',
            },

            keyframes: {
                camelWiggle: {
                    '0%, 100%': { transform: 'translateY(5px) rotate(-5deg)' },
                    '50%': { transform: 'translateY(0) rotate(5deg)' },
                },
                waveY: {
                    '0%, 100%': { transform: 'translateY(0)' },
                    '50%': { transform: 'translateY(5px)' },
                },
            }
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
